export const isUrlInChildren: (a, b) => boolean = (parent, url) => {
  const children = parent.children;

  if ( !children )
    return false;

  for ( const child of children ) {
    if ( child.children )
      if ( isUrlInChildren(child, url) )
        return true;

    if ( child.url === url || url.includes(child.url) )
      return true;

  }

  return false;
}
